import React from "react";

import classNames from "classnames";

import { Arrow } from '../../../elements/icons/iconslib'
import styles from '../contentcards.module.scss';

export function ContentCardBanner({ data, onClick }) {
    const backgroundStyle = { backgroundImage: `url(${data.imageUrl})` }

    return (
        <>
            <a target="_blank" href={data.url} className={ classNames(styles.bannerCardLink) } onClick={onClick}>
                <div className= { classNames(styles.bannerCard) } style={backgroundStyle} >
                    <div className={ classNames(styles.texts) }>
                        {(data.title || data.extras.Title) && (
                            <div className={ classNames(styles.bannerCardHeader) } dangerouslySetInnerHTML={{__html: data.title || data.extras.Title}} />
                        )}
                        {(data.description || data.extras.Description) && (<p className={ classNames(styles.cardDescription) }>{data.description || data.extras.Description}</p>)}
                    </div>
                    {data.url && (<div className={ classNames(styles.linkWrapper) }><Arrow /></div>)}
                </div>
            </a>
        </>
    );
}